export default __webpack_public_path__ + "static/happy-clients-684aaea26682b3078a892a10c92c3ddf.png";